import * as styles from './aspect-name-list.scss';

type PropsType = {
    names: Array<string>;
};

// BST-10541: shared renderer for the strong/weak aspect-name columns, used by both
// the aspects-by-locations table and the single-location page.
export function AspectNameList({names}: PropsType): JSX.Element {
    if (names.length === 0) {
        return <>—</>;
    }

    return (
        <ul className={styles.AspectNameList}>
            {names.map((name) => (
                <li key={name}>{name}</li>
            ))}
        </ul>
    );
}
